module.exports = __webpack_public_path__ + "img/icon-close.19a71f8c.svg";